import MockupSimpleForm from './MockupSimpleForm'

export default MockupSimpleForm
